import React, { useMemo } from 'react';
import styles from './index.modules.scss';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';

/**
 * 这个是用于在滚动容器底部展示数据的各种状态的，有加载中和加载完毕两种
 * @param {*} props: loadingMore, noMore
 * @returns
 */
export const Bottom = (props) => {
  const { loadingMore, noMore, className, onClick } = props;

  const Bottom = useMemo(() => {
    if (loadingMore) {
      return <div className={styles.title}>loading...</div>;
    } else if (noMore) {
      return (
        <Divider
          label={translate('history_bottom')}
          color="#EBEBEB"
          className={className}
          styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
        />
      );
    } else if (onClick) {
      return (
        <span className="text-primary text-[14px] font-medium cursor-pointer" onClick={onClick}>
          {translate('load_more')}
        </span>
      );
    } else {
      return null;
    }
  }, [loadingMore, noMore, className, onClick]);

  return Bottom;
};
